import { render } from "./EventNotification.vue?vue&type=template&id=e57590d2"
import script from "./EventNotification.vue?vue&type=script&lang=js"
export * from "./EventNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__